import React, { useState, createContext, useContext } from 'react';
const GameContext = createContext(null);
export const GameProvider = ({
  children
}) => {
  const [collectedStars, setCollectedStars] = useState([]);
  const [playerPosition, setPlayerPosition] = useState({
    x: 400,
    y: 300
  });
  // Add a star to the collected stars
  const collectStar = starId => {
    if (!collectedStars.includes(starId)) {
      setCollectedStars([...collectedStars, starId]);
    }
  };
  // Add a star to the inventory
  const addStar = starId => {
    collectStar(starId);
  };
  // Update player position
  const updatePlayerPosition = position => {
    setPlayerPosition(position);
  };
  return <GameContext.Provider value={{
    collectedStars,
    collectStar,
    addStar,
    playerPosition,
    updatePlayerPosition
  }} data-id="element-174">
      {children}
    </GameContext.Provider>;
};
export const useGame = () => useContext(GameContext);